module.exports = require("friendly-errors-webpack-plugin");


//////////////////
// WEBPACK FOOTER
// external "friendly-errors-webpack-plugin"
// module id = 34
// module chunks = 0